import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { Facsimile } from "../types"
import { API_URL } from "../constants"

export function useFacsimiliList(params: Record<string, string> = {}) {
  return useList<Facsimile>(`${API_URL}/admin/facsimili`, {
    query: params,
  })
}

export function useFacsimile(id: number | undefined) {
  return useDetail<Facsimile>(`${API_URL}/admin/facsimili`, id?.toString())
}

export function useFacsimileCreate() {
  return useCreate<Facsimile>(`${API_URL}/admin/facsimili`)
}

export function useFacsimileUpdate() {
  return useUpdate<Facsimile>(`${API_URL}/admin/facsimili`)
}

export function useFacsimileDelete() {
  return useDelete<Facsimile>(`${API_URL}/admin/facsimili`)
}